import { Axios } from "./request";

const API_URL = "usersapi/v1/basic/";

export const BASIC_INFORMATION_API = {
  GetBasicInformation: () => {
    return Axios.get(`${API_URL}GetBasicInformation`);
  },
  AddBasicInformation: (body) => {
    return Axios.post(`${API_URL}AddBasicInformation`, body);
  },
  EditBasicInformation: (body) => {
    return Axios.put(`${API_URL}EditBasicInformation`, body);
  },
  GetDetailBasicInformation: (profileNumber) => {
    return Axios.get(`${API_URL}GetDetailBasicInformation?profileNumber=${profileNumber}`);
  },
  GetDetailBasicInformationAfterApprovalInspector: (profileNumber) => {
    return Axios.get(
      `${API_URL}GetDetailBasicInformationAfterApprovalInspector?profileNumber=${profileNumber}`
    );
  },
};
